import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EmergencyAcceptedModal = ({ caseData, onClose }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  if (!caseData) return null;

  const locale = i18n.language === "ar" ? "ar-EG" : "en-US";
  const pets = (caseData.pets || []).map((p) => p.name).join(", ");
  const createdAt = caseData.created_at || caseData.createdAt;
  const noData = t("emergencyQueue.common.noData");

  return (
    <div
      className="reception-modal-overlay"
      dir={i18n.dir()}
      lang={i18n.language}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="reception-modal eq-modal">
        <div className="reception-modal-header">
          <span className="reception-modal-title">
            {t("emergencyQueue.modal.title")}
          </span>
          <button className="reception-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 600, marginBottom: 6 }}>
            {t("emergencyQueue.modal.caseRef")}
          </div>
          <div>#{caseData.case_ref || caseData.id}</div>
        </div>
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 600, marginBottom: 6 }}>
            {t("emergencyQueue.modal.pets")}
          </div>
          <div>{pets || noData}</div>
        </div>
        <div className="eq-description">
          <div className="eq-section-title">
            {t("emergencyQueue.modal.description")}
          </div>
          <div className="eq-description-box">
            {caseData.problem_description || noData}
          </div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 600, marginBottom: 6 }}>
            {t("emergencyQueue.modal.created")}
          </div>
          <div>
            {createdAt
              ? new Date(createdAt).toLocaleString(locale)
              : noData}
          </div>
        </div>
        <div className="reception-modal-actions">
          <button
            type="button"
            className="reception-action-btn"
            onClick={() => {
              const preferredId = caseData._senderId || null;
              const ownerFallback =
                caseData.pets &&
                  caseData.pets.length > 0 &&
                  caseData.pets[0]?.owner?.id
                  ? caseData.pets[0].owner.id
                  : null;
              const targetId = preferredId || ownerFallback;
              const clinicId = caseData.clinic_id;
              if (clinicId && targetId) {
                navigate(`/medical/clinic/${clinicId}/chat/${targetId}`);
                onClose();
              }
            }}
          >
            {t("emergencyQueue.buttons.chat")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmergencyAcceptedModal;

